import React from 'react';
import PropTypes from 'prop-types';

import Slot from '../../Slot';
import './styles.css';

class TwoLinesContent extends React.Component {
  render() {
    const {
      firstSlotData,
      secondSlotData,
      theme,
    } = this.props;

    return (
      <div className="TwoLinesContent__root">
        <Slot
          theme={theme}
          label={firstSlotData.label}
          value={firstSlotData.value}
          separator
        />
        <Slot
          theme={theme}
          label={secondSlotData.label}
          value={secondSlotData.value}
        />
      </div>
    );
  }
}

TwoLinesContent.propTypes = {
  firstSlotData: PropTypes.objectOf(PropTypes.any).isRequired,
  secondSlotData: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default TwoLinesContent;
